<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="6.66797" y="6.66669" width="10" height="10" rx="2" stroke="#AC986A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.332 6.66665V4.99998C13.332 4.07951 12.5858 3.33331 11.6654 3.33331H4.9987C4.07822 3.33331 3.33203 4.07951 3.33203 4.99998V11.6666C3.33203 12.5871 4.07822 13.3333 4.9987 13.3333H6.66536" stroke="#AC986A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>